import template   from './cookies-consent.html'
import controller from './cookies-consent.controller'
import './cookies-consent.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/cookies-consent/cookies-consent.component.js